"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallInfoFactory = void 0;
var ErrorStackParser = __importStar(require("error-stack-parser"));
var StackGenerator = __importStar(require("stack-generator"));
var CallInfoFactory = (function () {
    function CallInfoFactory() {
    }
    CallInfoFactory.prototype.create = function () {
        try {
            throw new Error();
        }
        catch (err) {
            return this.getCallInfo(err);
        }
    };
    CallInfoFactory.prototype.getCallInfo = function (stackError) {
        try {
            var stackFrames = this.getStackTraceSync(stackError);
            var frame = stackFrames[stackFrames.length - 1];
            return {
                file: '/' + frame.fileName.substring(frame.fileName.lastIndexOf('/') + 1),
                line: frame.lineNumber,
                method: frame.functionName,
            };
        }
        catch (err) {
            return {
                file: undefined,
                line: undefined,
                method: undefined,
            };
        }
    };
    CallInfoFactory.prototype.getStackTraceSync = function (err) {
        var isShapedLikeParsableError = err.stack || err['opera#sourceloc'];
        return isShapedLikeParsableError ? ErrorStackParser.parse(err) : StackGenerator.backtrace();
    };
    return CallInfoFactory;
}());
exports.CallInfoFactory = CallInfoFactory;
